// -----------------------------------------------------------------------------
// UTIL/ICONS
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
function elt(type, props, ...children) {
    let dom = document.createElementNS("http://www.w3.org/2000/svg", type);
    Object.keys(props).forEach(key => {
        dom.setAttributeNS(null, key, props[key]);
    });
    for (let child of children) {
        if (typeof child != "string")
            dom.appendChild(child);
        else
            dom.appendChild(document.createTextNode(child));
    }
    return dom;
}
function line(x1, y1, x2, y2) {
    return elt("line", { x1, y1, x2, y2 });
}
function path(d) {
    return elt("path", { d: d });
}
function circle(cx, cy, r) {
    return elt("circle", { cx, cy, r });
}
function rect(x, y, width, height, rx) {
    return elt("rect", { x, y, width, height, rx });
}
function polyline(points) {
    return elt("polyline", { points });
}
function svg(name, ...children) {
    return elt("svg", {
        viewBox: "0 0 24 24",
        class: "icon " + name
    }, elt("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), ...children);
}
// -----------------------------------------------------------------------------
function bold(name) {
    return svg(name, elt("path", { d: "M7 5h6a3.5 3.5 0 0 1 0 7h-6z", "vector-effect": "non-scaling-stroke" }), elt("path", { d: "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7", "vector-effect": "non-scaling-stroke" }));
}
function underline(name) {
    return svg(name, line(6, 20, 18, 20), path("M8 5v6a4 4 0 0 0 8 0v-6"));
}
function italic(name) {
    return svg(name, line(11, 5, 17, 5), line(7, 19, 13, 19), line(14, 5, 10, 19));
}
function emphasis(name) {
    return svg(name, path("M16 5h-8v10h8m-1 -5h-7"), line(6, 20, 6, 20.01), line(10, 20, 10, 20.01), line(14, 20, 14, 20.01), line(18, 20, 18, 20.01));
}
function rule(name) {
    return svg(name, path("M14 3v4a1 1 0 0 0 1 1h4"), path("M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1"), path("M3 14h3m4.5 0h3m4.5 0h3"), path("M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2"));
}
function indent(name) {
    return svg(name, line(20, 6, 9, 6), line(20, 12, 13, 12), line(20, 18, 9, 18), path("M4 8l4 4l-4 4"));
}
function outdent(name) {
    return svg(name, line(20, 6, 13, 6), line(20, 12, 11, 12), line(20, 18, 13, 18), path("M8 8l-4 4l4 4"));
}
function link(name) {
    return svg(name, elt("path", { d: "M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5" }), elt("path", { d: "M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5" }), elt("g", {
        class: "icon-unlink"
    }, line(16, 21, 16, 19), line(19, 16, 21, 16), line(3, 8, 5, 8), line(8, 3, 8, 5)));
}
function unlink(name) {
    return svg(name, path("M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"), path("M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"), line(16, 21, 16, 19), line(19, 16, 21, 16), line(3, 8, 5, 8), line(8, 3, 8, 5));
}
function paragraph(name) {
    return svg(name, path("M19.5,4H9.12a5.13,5.13,0,0,0,0,10.25h.73"), path("M16,20V4"), path("M10,20V4"));
}
function h1(name) {
    return svg(name, line(3, 5, 3, 19), line(3, 12, 12, 12), line(12, 5, 12, 19), path("M20 19v-10l-3 3"));
}
function h2(name) {
    return svg(name, line(3, 5, 3, 19), line(3, 12, 12, 12), line(12, 5, 12, 19), path("M21 19h-5l4.47 -5.96a2.5 2.5 0 1 0 -4.47 -1.54"));
}
function h3(name) {
    return svg(name, line(3, 5, 3, 19), line(3, 12, 12, 12), line(12, 5, 12, 19), path("M16 11.5a2.5 2.5 0 1 1 2.5 2.5a2.5 2.5 0 1 1 -2.5 2.5"));
}
function bulletlist(name) {
    return svg(name, line(9, 6, 20, 6), line(9, 12, 20, 12), line(9, 18, 20, 18), line(5, 6, 5, 6.01), line(5, 12, 5, 12.01), line(5, 18, 5, 18.01));
}
function checklist(name) {
    return svg(name, circle(5, 6, 2), circle(5, 12, 2), circle(5, 18, 2), line(11, 6, 20, 6), line(11, 12, 20, 12), line(11, 18, 20, 18));
}
function orderedlist(name) {
    return svg(name, path("M11 6h9"), path("M11 12h9"), path("M12 18h8"), path("M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"), path("M6 10v-6l-2 2"));
}
function blockquote(name) {
    return svg(name, path("M6 15h15"), path("M21 19h-15"), path("M15 11h6"), path("M21 7h-6"), path("M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"), path("M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"));
}
function plus(name) {
    return svg(name, line(12, 5, 12, 19), line(5, 12, 19, 12));
}
function chevronRight(name) {
    return svg(name, polyline("9 6 15 12 9 18"));
}
function chevronLeft(name) {
    return svg(name, polyline("15 6 9 12 15 18"));
}
function pointer(name) {
    return elt("svg", {
        viewBox: "0 0 48 16",
        class: "icon " + name
    }, path("M0 16 L24 4 L48 16"));
}
function edit(name) {
    return svg(name, path("M12 15l8.385 -8.415a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3z"), path("M16 5l3 3"), path("M9 7.07a7.002 7.002 0 0 0 1 13.93a7.002 7.002 0 0 0 6.929 -5.999"));
}
function externalLink(name) {
    return svg(name, path("M11 7h-5a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-5"), line(10, 14, 20, 4), polyline("15 4 20 4 20 9"));
}
function photo(name) {
    return svg(name, line(15, 8, 15.01, 8), rect(4, 4, 16, 16, 3), path("M4 15l4 -4a3 5 0 0 1 3 0l5 5"), path("M14 14l1 -1a3 5 0 0 1 3 0l2 2"));
}
function arrowsRight(name) {
    return svg(name, line(5, 12, 19, 12), line(13, 18, 19, 12), line(13, 6, 19, 12));
}
function x(name) {
    return svg(name, line(18, 6, 6, 18), line(6, 6, 18, 18));
}
function circleX(name) {
    return svg(name, circle(12, 12, 9), path("M10 10l4 4m0 -4l-4 4"));
}
function artboard(name) {
    return svg(name, rect(8, 8, 8, 8, 1), line(3, 8, 4, 8), line(3, 16, 4, 16), line(8, 3, 8, 4), line(16, 3, 16, 4), line(20, 8, 21, 8), line(20, 16, 21, 16), line(8, 20, 8, 21), line(16, 20, 16, 21));
}
function nowrap(name) {
    return svg(name, path("M4 6l10 0"), path("M4 18l10 0"), path("M4 12h17l-3 -3m0 6l3 -3"));
}
function wrap(name) {
    return svg(name, path("M4 6l10 0"), path("M4 18l10 0"), path("M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2"));
}
export default {
    link,
    unlink,
    bold,
    underline,
    italic,
    emphasis,
    rule,
    indent,
    outdent,
    paragraph,
    h1,
    h2,
    h3,
    bulletlist,
    checklist,
    orderedlist,
    blockquote,
    plus,
    chevronLeft,
    chevronRight,
    pointer,
    edit,
    externalLink,
    photo,
    arrowsRight,
    x,
    circleX,
    artboard,
    nowrap,
    wrap
};
